import {
  FORM_FIELD_FONT_SIZE,
  FORM_FIELD_FONT_WEIGHT,
  FORM_FIELD_HEIGHT,
  FORM_FIELD_INPUT_PADDING,
} from '../../theme_v2/form-field';

/**
 * Sx helper compartilhado para o root do MuiInputBase em componentes V2.
 * Aplica bgcolor condicional e garante minHeight via token do tema.
 */
export const formFieldRootSx = (disabled) => ({
  bgcolor: disabled ? 'transparent' : 'background.paper',
  '&:not(.MuiInputBase-multiline)': { minHeight: FORM_FIELD_HEIGHT },
});

/** Layout interno do MuiPickersOutlinedInput — ícone dentro da borda, altura fixa 40px */
export const pickerInputRootSx = {
  alignItems: 'center',
  boxSizing: 'border-box',
  height: FORM_FIELD_HEIGHT,
  minHeight: FORM_FIELD_HEIGHT,
  maxHeight: FORM_FIELD_HEIGHT,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: '8px',
  overflow: 'hidden',
};

/** Padding só horizontal — vertical vem do flex + height fixa (evita “campo gigante”) */
export const pickerSectionListSx = {
  flex: 1,
  minWidth: 0,
  alignSelf: 'center',
  padding: '0 12px',
  paddingRight: '4px',
  fontSize: FORM_FIELD_FONT_SIZE,
  fontWeight: FORM_FIELD_FONT_WEIGHT,
  lineHeight: '24px',
};

export const pickerInputBaseSx = {
  height: FORM_FIELD_HEIGHT,
  minHeight: FORM_FIELD_HEIGHT,
  maxHeight: FORM_FIELD_HEIGHT,
  padding: 0,
  boxSizing: 'border-box',
};

export const pickerAdornmentSx = {
  marginLeft: 0,
  marginRight: 0,
  flexShrink: 0,
  height: 'auto',
  maxHeight: 'none',
  '& .MuiIconButton-root': {
    padding: 4,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.125rem',
  },
};

/**
 * sx para slotProps.textField dos pickers MUI X v8 (DatePicker, TimePicker, etc.).
 * Pickers usam MuiPickersOutlinedInput — não herdam overrides de MuiOutlinedInput.
 */
export const pickerTextFieldSx = (disabled) => ({
  '& .MuiFormControl-root': {
    margin: 0,
  },
  '& .MuiPickersInputBase-root': {
    ...pickerInputBaseSx,
    bgcolor: disabled ? 'transparent' : 'background.paper',
  },
  '& .MuiPickersOutlinedInput-root': {
    ...formFieldRootSx(disabled),
    ...pickerInputRootSx,
  },
  '& .MuiPickersOutlinedInput-root.Mui-disabled, & .MuiPickersInputBase-root.Mui-disabled': {
    ...pickerInputBaseSx,
  },
  '& .MuiPickersSectionList-root': {
    color: 'text.primary',
    ...pickerSectionListSx,
  },
  '& .MuiPickersSectionList-root.Mui-disabled': {
    ...pickerSectionListSx,
    WebkitTextFillColor: 'unset',
  },
  '& .MuiOutlinedInput-input': {
    color: 'text.primary',
    fontSize: FORM_FIELD_FONT_SIZE,
    fontWeight: FORM_FIELD_FONT_WEIGHT,
    lineHeight: '24px',
    padding: FORM_FIELD_INPUT_PADDING,
  },
  '& .MuiInputAdornment-root': pickerAdornmentSx,
  '& .MuiInputAdornment-root .MuiIconButton-root.Mui-disabled': {
    padding: 4,
  },
});

/** slotProps.openPickerButton compartilhado entre pickers */
export const pickerOpenButtonSlotProps = {
  size: 'small',
};

export const DEFAULT_PICKER_ERROR_MESSAGE = 'O campo é obrigatório';

/** slotProps.textField compartilhado — paridade com InputV2 (error + helperText + size small) */
export const pickerTextFieldSlotProps = ({
  disabled = false,
  error = false,
  helperText = DEFAULT_PICKER_ERROR_MESSAGE,
} = {}) => ({
  fullWidth: true,
  size: 'small',
  error: Boolean(error),
  helperText: error ? helperText : '',
  sx: pickerTextFieldSx(disabled),
});
